import { bootstrap } from '../../../utils/vuex'
import * as types from './mutation-types'
import Vue from 'vue'
// @todo kiszervezes, ha sok lesz
// import getters from './getters'
// import actions from './actions'
// import mutations from './mutations'

const state = () => {
  return {
    helpyData: [],
    helpyFilter: [],
    index: {},
    presetHelpyNodePath: [],
    selectedNode: null,
    selectedLeaf: null,
    showHelpy: false,
  }
}

const getters = {
  helpyData: (state) => state.helpyData,
  helpyFilter: (state) => state.helpyFilter,
  index: (state) => state.index,
  selectedNode: (state) => state.selectedNode,
  selectedLeaf: (state) => state.selectedLeaf,
  showHelpy: (state) => state.showHelpy,
}

const actions = {
  setHelpyData({ commit }, { helpyData }) {
    commit(types.SET_HELPY_DATA, { helpyData })
  },
  setHelpyFilter({ commit, state }, { filter }) {
    commit(types.SET_HELPY_FILTER, { filter })
  },
  setIndex({ commit }, { id, node }) {
    commit(types.SET_INDEX, { id, node })
  },
  setSelectedLeaf({ commit }, { selectedLeaf }) {
    commit(types.SET_SELECTED_LEAF, { selectedLeaf })
  },
  setSelectedNode({ commit }, { selectedNode }) {
    commit(types.SET_SELECTED_NODE, { selectedNode })
  },
  setShowHelpy({ commit }, { showHelpy }) {
    commit(types.SET_SHOW_HELPY, { showHelpy })
  },
}

const mutations = {
  [types.SET_HELPY_DATA](state, { helpyData }) {
    Vue.set(state, 'helpyData', helpyData)
  },
  [types.SET_HELPY_FILTER](state, { filter }) {
    Vue.set(state, 'helpyFilter', Array.isArray(filter) ? filter : [filter])
  },
  [types.SET_INDEX](state, { id, node }) {
    Vue.set(state.index, id, node)
  },
  [types.SET_SELECTED_LEAF](state, { selectedLeaf }) {
    Vue.set(state, 'selectedLeaf', selectedLeaf)
  },
  [types.SET_SELECTED_NODE](state, { selectedNode }) {
    Vue.set(state, 'selectedNode', selectedNode)
  },
  [types.SET_SHOW_HELPY](state, { showHelpy }) {
    Vue.set(state, 'showHelpy', showHelpy)
  },
}

export default bootstrap({
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
})
